import { Box, Card, CardContent, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";
import { CreditosOrganizacion, CreditosSuborganizacion, CreditosSuscripcion, CreditosUsario } from "../../../../interfaces/SuperAdmin/Pages/iDataCreditos";
import CustomPieChart from "../CustomPieChart";

const nameMap: Record<string, string> = {
  creditos_gastados: "Gastados",
  creditos_disponibles: "Disponibles",
  creditos_desperdiciados: "Desperdiciados",
};

type Info = Record<string, string | number>;

interface Props {
  credits:
      | CreditosOrganizacion
      | CreditosSuborganizacion
      | CreditosUsario
      | CreditosSuscripcion;
}

const SingleEntityBarChart: FC<Props> = ({ credits }) => {

  // Transformamos el objeto de créditos a un array
  const [formattedInfo, setFormattedInfo] = useState<Info[]>([]);

  useEffect(() => {
    if (credits) {
      // Transformamos el objeto en un array de arrays
      const arrays = Object.entries(credits);

      // Quitamos los arrays que no contengan un número como id_organizacion
      const filtered = arrays.filter(
        ([key, value]) =>
          typeof value === "number" && key !== "creditos_totales"
      );

      const result: Info[] = filtered.map(([key, value]) => ({
        name: nameMap[key] || key,
        value,
      }));

      setFormattedInfo(result);
    }
  }, [credits]);

  return (
    <Box display="flex" gap={2} width={1}>
      <Box flex={3}>
        <Card sx={{ width: 1 }}>
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              color: "#336B87",
              gap: 2,
            }}
          >
            <Typography variant="h6" fontWeight="bold">
              Uso de créditos
            </Typography>
            <ResponsiveContainer width="100%" height={240}>
              <BarChart
                layout="vertical"
                data={formattedInfo}
                margin={{ top: 5, right: 30, left: 40, bottom: 5 }}
                maxBarSize={40}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" />
                <YAxis dataKey="name" type="category" width={100} />
                <Tooltip
                  content={({ active, payload }) => {
                    if (active && payload && payload.length) {
                      const { name, value } = payload[0].payload;
                      return (
                        <div
                          style={{
                            background: "#fff",
                            padding: 10,
                            border: "1px solid #ccc",
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: "bold", fontSize: "16px" }}
                          >
                            {name}
                          </Typography>
                          <Typography variant="body2" sx={{ fontSize: "14px" }}>
                            <span style={{ fontWeight: "bold" }}>Total: </span>
                            {value}
                          </Typography>
                        </div>
                      );
                    }
                    return null;
                  }}
                />
                <Bar dataKey="value" fill="#336B87" />
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </Box>

      <Box flex={1}>
        <CustomPieChart
          data={formattedInfo}
          title="Distribución"
          label="name"
          value="value"
          hasCredits={formattedInfo.some((item) => item["value"])}
        />
      </Box>
    </Box>
  );
};

export default SingleEntityBarChart;
